import { pwaLinkTagClick, showPwaLoader } from "@/redux/actions/pwaAction";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "./GifLoader.module.scss"

const PageGifLoader = () => { 
	const dispatch = useDispatch();
	const [showLoader, setShowLoader] = useState(false);
	const [loaderRepeat, setLoaderRepeat] = useState(0);
	const isPWAApp = useSelector((state) => state.pwa.is_PWA);
	const showPwaLoaderFlag = useSelector((state) => state.pwa.pwa_loader);
	const pwaLinkTag = useSelector((state) => state.pwa.pwa_link_tag_click);
	const handleClick = (val,linkTag = false) => {
		setShowLoader(val); 
		if(linkTag) {
			dispatch(pwaLinkTagClick(true)); 
		}
	}

	//function which contains set timeout
	const setDelay = () => {
		setTimeout(() => {
			setShowLoader(false)
			dispatch(showPwaLoader(false)) 
		}, 2000)
	}

	useEffect(() => {
		setTimeout(() => {
			if(loaderRepeat <= 5) {
				setLoaderRepeat(loaderRepeat+1)
			}
		}, 1000);
	}, [loaderRepeat]);

	useEffect(() => {
		if(showLoader || showPwaLoaderFlag) {
			document.querySelector("body").classList.add("disable-scroll");
		} else {
			document.querySelector("body").classList.remove("disable-scroll");
		}
		if(isPWAApp && (showLoader || showPwaLoaderFlag)){
			setDelay();
		}
	}, [showLoader,showPwaLoaderFlag]);

	useEffect(() => {
		setTimeout(() => {
			setShowLoader(false)
			dispatch(showPwaLoader(false)) 
		}, 2000);
	}, [pwaLinkTag]);

	useEffect(() => {
		setShowLoader(false)
		}, []);

	useEffect(() => {
	if(isPWAApp && loaderRepeat <= 5) {
		var Anchors = document.getElementsByTagName("a");
		// var divs = document.getElementsByClassName("show-page-loader")
		for (var i = 0; i < Anchors.length ; i++)
		{
			if(Anchors[i]?.parentElement?.classList.contains('pwa-link-tag')) {
				Anchors[i].addEventListener("click", 
				function () { 
					return handleClick(true,true); 
				}, { once: true });
			}
			else if(!Anchors[i].classList.contains('exclude-pwa-loader') && Anchors[i].getAttribute("href")) {
				Anchors[i].addEventListener("click", 
				function () { 
					return handleClick(true); 
				}, { once: true });
			} else {
			
		}
		}
		// for (var i = 0; i < divs.length ; i++)
		// {
		// 	divs[i].addEventListener("click", function (e) { 
		// 		return handleClick(true); 
		// 	}, { once: true });
		// }
	}
	}, [isPWAApp,loaderRepeat]);
	
	return (
	<>
		{/* check the loading state and homepage */}
		{isPWAApp && (showLoader || showPwaLoaderFlag) && <div className={styles.loader_container}>
			{/* {
			setTimeout(() => {
				setShowLoader(false)
				dispatch(showPwaLoader(false)) 
			}, 2000)
			} */}
		<div className={styles.loader}></div>
		</div>}
	</>
	);
} 

export default PageGifLoader;
